import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  speakers: [],
  presentationList: [],

  getPresentationLoading: false,
  getPresentationError: null,
  viewPresentationLoading: false,
  viewPresentationError: null,
  selectedPresentation: null,
  updatePresentationLoading: false,
  updatePresentationError: null,
  createPresentationLoading: false,
  createPresentationError: null,
  deletePresentationLoading: false,
  deletePresentationError: null,

  getSpeakersLoading: false,
  getSpeakersError: null,

  AssignPresetationLoading: false,
  AssignPresetationError: null,

  getPresentationSessionLoading: false,
  getPresentationSessionError: null,
  selectedPresentationSession: null,
};

export const fetchPresentations = createAsyncThunk(
  "presentation/fetchPresentations",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("OrviSlideToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to fetch presentations",
        );
      }
      const data = await response.json();
      const presentationData = data.data;
      return presentationData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const viewPresentation = createAsyncThunk(
  "presentation/viewPresentation",
  async (uuid, { rejectWithValue }) => {
    const token = localStorage.getItem("OrviSlideToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations/${uuid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to view presentation",
        );
      }
      const data = await response.json();
      const presentationData = data.data;
      return presentationData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const viewPublicPresentation = createAsyncThunk(
  "presentation/viewPublicPresentation",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/presentations/${uuid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to view presentation",
        );
      }
      const data = await response.json();
      const presentationData = data.data || data;
      return presentationData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const viewPresentationSession = createAsyncThunk(
  "presentation/viewPresentationSession",
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}/presentation`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to view presentation",
        );
      }
      const data = await response.json();
      const presentationData = data.data;
      return presentationData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const createPresentation = createAsyncThunk(
  "presentation/createPresentation",
  async (presentationData, { rejectWithValue }) => {
    const token = localStorage.getItem("OrviSlideToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: presentationData,
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to create presentation",
        );
      }
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const updatePresentation = createAsyncThunk(
  "presentation/updatePresentation",
  async ({ uuid, data }, { rejectWithValue }) => {
    const token = localStorage.getItem("OrviSlideToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations/${uuid}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: data,
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to update presentation",
        );
      }
      const result = await response.json();
      console.log(result, "result");

      return result;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const startSession = createAsyncThunk(
  "presentations/startSession",
  async ({ presentationId, email, city }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sessions/start`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            presentation_id: presentationId,
            email: email,
            city: city,
          }),
        },
      );
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to start session");
      }
      return data.data || data;
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  },
);

export const joinSession = createAsyncThunk(
  "presentations/joinSession",
  async ({ sessionId, presentationId, attendeeId }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}/join`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            presentation_id: String(presentationId),
            attendee_id: String(attendeeId),
          }),
        },
      );
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to join session");
      }
      return data.data || data;
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  },
);

export const endSession = createAsyncThunk(
  "presentations/endSession",
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}/end`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to end session");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  },
);

export const submitAnswerToAPI = createAsyncThunk(
  "presentations/submitAnswerToAPI",
  async (answerPayload, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/answers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(answerPayload),
        },
      );
      if (!response.ok) {
        return rejectWithValue("Failed to submit answer");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  },
);

export const deletePresentation = createAsyncThunk(
  "presentation/deletePresentation",
  async (presentationId, { rejectWithValue }) => {
    const token = localStorage.getItem("OrviSlideToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations/${presentationId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to delete presentation",
        );
      }
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchSpeakers = createAsyncThunk(
  "presentation/fetchSpeakers",
  async (presentationId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("OrviSlideToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/speakers/${presentationId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to fetch Speakers",
        );
      }
      const data = await response.json();
      const speakersData = data.data;
      return speakersData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const assignPresentation = createAsyncThunk(
  "presentation/assignPresentation",
  async ({ speakersIds, presentationId }, { rejectWithValue }) => {
    const token = localStorage.getItem("OrviSlideToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/presentations/${presentationId}/assign-admin`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: speakersIds,
        },
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(
          errorData.message
            ? errorData
            : errorData.error || "Failed to assign presentation",
        );
      }
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const presentationSlice = createSlice({
  name: "presentation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPresentations.pending, (state) => {
        state.getPresentationLoading = true;
        state.getPresentationError = null;
      })
      .addCase(fetchPresentations.fulfilled, (state, action) => {
        state.getPresentationLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchPresentations.rejected, (state, action) => {
        state.getPresentationLoading = false;
        state.getPresentationError = action.payload;
      })

      .addCase(viewPresentation.pending, (state) => {
        state.viewPresentationLoading = true;
        state.viewPresentationError = null;
        state.selectedPresentation = null;
      })
      .addCase(viewPresentation.fulfilled, (state, action) => {
        state.viewPresentationLoading = false;
        state.selectedPresentation = action.payload;
      })
      .addCase(viewPresentation.rejected, (state, action) => {
        state.viewPresentationLoading = false;
        state.viewPresentationError = action.payload;
      })

      .addCase(viewPublicPresentation.pending, (state) => {
        state.viewPresentationLoading = true;
        state.viewPresentationError = null;
        state.selectedPresentation = null;
      })
      .addCase(viewPublicPresentation.fulfilled, (state, action) => {
        state.viewPresentationLoading = false;
        state.selectedPresentation = action.payload;
      })
      .addCase(viewPublicPresentation.rejected, (state, action) => {
        state.viewPresentationLoading = false;
        state.viewPresentationError = action.payload;
      })

      .addCase(updatePresentation.pending, (state) => {
        state.updatePresentationLoading = true;
        state.updatePresentationError = null;
      })
      .addCase(updatePresentation.fulfilled, (state, action) => {
        state.updatePresentationLoading = false;
        const updatedPresentation = action.payload.data || action.payload;
        state.selectedPresentation = updatedPresentation;
        state.list = state.list.map((presentation) =>
          presentation.id === updatedPresentation.id
            ? updatedPresentation
            : presentation,
        );
      })
      .addCase(updatePresentation.rejected, (state, action) => {
        state.updatePresentationLoading = false;
        state.updatePresentationError = action.payload;
      })
      .addCase(createPresentation.pending, (state) => {
        state.createPresentationLoading = true;
        state.createPresentationError = null;
      })
      .addCase(createPresentation.fulfilled, (state, action) => {
        state.createPresentationLoading = false;
        state.list.push(action.payload);
      })
      .addCase(createPresentation.rejected, (state, action) => {
        state.createPresentationLoading = false;
        state.createPresentationError = action.payload;
      })

      .addCase(deletePresentation.pending, (state) => {
        state.deletePresentationLoading = true;
        state.deletePresentationError = null;
      })
      .addCase(deletePresentation.fulfilled, (state, action) => {
        state.deletePresentationLoading = false;
        const deletedPresentationId = action.payload.id;
        state.list = state.list.filter(
          (presentation) => presentation.id !== deletedPresentationId,
        );
      })
      .addCase(deletePresentation.rejected, (state, action) => {
        state.deletePresentationLoading = false;
        state.deletePresentationError = action.payload;
      })

      // fetch speakers
      .addCase(fetchSpeakers.pending, (state) => {
        state.getSpeakersLoading = true;
        state.getSpeakersError = null;
      })
      .addCase(fetchSpeakers.fulfilled, (state, action) => {
        state.getSpeakersLoading = false;
        state.speakers = action.payload;
      })
      .addCase(fetchSpeakers.rejected, (state, action) => {
        state.getSpeakersLoading = false;
        state.getSpeakersError = action.payload;
      })

      // Assign presenattion

      .addCase(assignPresentation.pending, (state) => {
        state.AssignPresetationLoading = true;
        state.AssignPresetationError = null;
      })
      .addCase(assignPresentation.fulfilled, (state, action) => {
        state.AssignPresetationLoading = false;
        state.presentationList.push(action.payload);
      })
      .addCase(assignPresentation.rejected, (state, action) => {
        state.AssignPresetationLoading = false;
        state.AssignPresetationError = action.payload;
      })

      // view presentation session
      .addCase(viewPresentationSession.pending, (state) => {
        state.getPresentationSessionLoading = true;
        state.getPresentationSessionError = null;
        state.selectedPresentationSession = null;
      })
      .addCase(viewPresentationSession.fulfilled, (state, action) => {
        state.getPresentationSessionLoading = false;
        state.selectedPresentationSession = action.payload;
      })
      .addCase(viewPresentationSession.rejected, (state, action) => {
        state.getPresentationSessionLoading = false;
        state.getPresentationSessionError = action.payload;
      });
  },
});

export default presentationSlice.reducer;
